import { observable, action, runInAction } from 'mobx';
import { isEmpty, cloneDeep } from 'lodash';

import Color from '@tool/color';
import moIndex from '../../../store/index';
import { newRate, newValue } from '@tool/index';

const moSalaryYear = observable({
  xData: <any[]>[],
  yData: <any[]>[],
  overview: <any[]>[],
  labels: <any[]>[],
  tableLeft: <any[]>[],
  tableRight: <any[]>[],
  tableHead: <any[]>[],
});

const initSalaryYear = action((res: any) => {
  if (isEmpty(res)) return;

  const xData: any[] = [];
  const yData: any[] = [];
  const overview: any[] = [];
  const tableLeft: any[] = [];
  const tableRight: any[] = [];

  // console.log('涨薪率时间趋势 res --- ', res)

  res.data?.map((item: any) => {
    xData.push(item.date);
    yData.push(item.change_rate);
    tableLeft.push(item.date);
  });
  // tableLeft.unshift('年度');

  res.overview?.map((item: any) => {
    let text = '';
    item?.map((child: any) => {
      if (child.mark === 'change_rate') {
        text += newRate(child.value);
      } else {
        text += child.value;
      }
    });
    overview.push(text);
  });

  // tableRight.push(['涨薪率', '统计周期']);
  res.data?.map((item: any) => {
    tableRight.push([item.change_rate, item.date_period]);
  });

  moSalaryYear.xData = xData;
  moSalaryYear.yData = yData;
  moSalaryYear.tableLeft = tableLeft;
  moSalaryYear.tableRight = tableRight;
  moSalaryYear.overview = overview;
  moSalaryYear.tableHead = ['涨薪率', '统计周期'];
  moSalaryYear.labels = res.total_industry_data || [];
});

export default moSalaryYear;
export { initSalaryYear };
